import React from 'react';
import PropTypes from 'prop-types';

import Container, {
  Indicator, FilterLabel, FilterCount, IconWrapper,
} from './smart-filter.style';
import { SMART_FILTER_TYPES } from '../../../../../constants';
import SmartFilterIndicator from '../../smart-filter-indicator';
import colors from '../../../../../theme';

/**
 * The smart filter component
 * @param {object} props - Object containing the props for this component
 * @param {string} props.fieldId - ID of the smart filter
 * @param {string} props.label - Label to be displayed in the button
 * @param {string} props.smartFilterCount - Number to be displayed in the filterCount
 * @param {func} props.handleUpdateFilters - Function to update filters
 * @param {boolean} props.isActive - Specifies if this smart filter is active
 * @return {element}
 */
const SmartFilter = ({
  fieldId,
  label,
  handleUpdateFilters,
  smartFilterCount,
  isActive,
}) => {
  const toggleFilter = () => handleUpdateFilters(fieldId);

  let smartFilterType;
  switch (fieldId) {
    case (SMART_FILTER_TYPES.allLoads):
      smartFilterType = {
        color: colors.palette.blue[100],
        type: '',
      };
      break;
    case (SMART_FILTER_TYPES.loadsWithProblems):
      smartFilterType = {
        color: colors.palette.red[100],
        type: 'octagon',
      };
      break;
    case (SMART_FILTER_TYPES.lateLoads):
      smartFilterType = {
        color: colors.palette.orange[100],
        type: 'diamond',
      };
      break;
    case (SMART_FILTER_TYPES.withinTwoHours):
      smartFilterType = {
        color: colors.palette.custom.teal,
        type: '',
      };
      break;
    default:
      smartFilterType = {
        color: '',
        type: '',
      };
  }
  return (
    <Container
      data-testid="Smart Filter"
      fieldId={fieldId}
      isActive={isActive}
      onClick={toggleFilter}
    >
      <Indicator>
        <SmartFilterIndicator
          type={isActive ? 'radioButtonFilled' : 'radioButtonCircle'}
          color={isActive ? colors.palette.white : smartFilterType.color}
          opacity="1.0"
          size="20"
        />
      </Indicator>
      <FilterLabel>{label}</FilterLabel>
      {fieldId !== SMART_FILTER_TYPES.allLoads && <FilterCount>{smartFilterCount}</FilterCount>}
      <IconWrapper>
        <SmartFilterIndicator
          type={smartFilterType.type}
          color={isActive ? colors.palette.white : smartFilterType.color}
          opacity={isActive ? '0.5' : '1.0'}
          size="14"
        />
      </IconWrapper>
    </Container>
  );
};

SmartFilter.propTypes = {
  fieldId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  handleUpdateFilters: PropTypes.func.isRequired,
  smartFilterCount: PropTypes.number,
  isActive: PropTypes.bool.isRequired,
};

SmartFilter.defaultProps = {
  smartFilterCount: null,
};

export default SmartFilter;
